import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col items-center justify-center font-montserrat bg-gray-lp-100" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center w-max gap-y-6 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Valid = _resolveComponent("Valid")!
  const _component_ErrorToken = _resolveComponent("ErrorToken")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.tokenResponse.isValid)
          ? (_openBlock(), _createBlock(_component_Valid, { key: 0 }))
          : (_openBlock(), _createBlock(_component_ErrorToken, { key: 1 }))
      ])
    ]),
    _createVNode(_component_Loading, {
      modelValue: _ctx.loadingModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadingModal = $event))
    }, null, 8, ["modelValue"]),
    (_ctx.messageModalData.open)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.messageModalData, {
          title: _ctx.$t(_ctx.messageModalData.title),
          message: _ctx.$t(_ctx.messageModalData.message)
        }), null, 16, ["title", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}